package tta.destinigo.talktoastro.shared.persentation

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Composable
fun MobileWithCountryCodeEditTextSingle(
    modifier: Modifier = Modifier,
    selectedCountry: String,
    mobileText: String,
    label: @Composable () -> Unit,
    placeHolder: @Composable () -> Unit,
    supportingText: @Composable () -> Unit,
    onMobileChange: (String) -> Unit,
    onCountryCodeChange: (String) -> Unit,
    isError: Boolean = false,
    countryList: List<CountryShared>
) {
    var isDropdownVisible by remember { mutableStateOf(false) }

    Box(modifier = modifier) {
        OutlinedTextField(
            value = mobileText,
            onValueChange = { input ->
                if (input.all { it.isDigit() }) {
                    onMobileChange(input)
                }
            },
            label = { label() },
            placeholder = { placeHolder() },
            singleLine = true,
            prefix = {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.clickable { isDropdownVisible = true }
                ) {
                    Text(text = selectedCountry, style = MaterialTheme.typography.bodyMedium.copy(
                        fontWeight = FontWeight.Bold
                    ))
                    Icon(
                        imageVector = Icons.Default.ArrowDropDown,
                        contentDescription = "Select Country Code",
                        modifier = Modifier.padding(start = 4.dp)
                    )
                }
            },
            supportingText = {
                supportingText()
            },
            isError = isError, // You can replace with error state logic
            modifier = Modifier.fillMaxWidth(),
            colors = OutlinedTextFieldDefaults.colors(
                focusedContainerColor = Color.Transparent,
                unfocusedContainerColor = Color.Transparent,
                focusedBorderColor = Color(0xFF112B60),
                unfocusedBorderColor = Color.Gray
            ),
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number)
        )

//         Dropdown for country code selection

        if (isDropdownVisible){
            DropDownLongList(
                onDismiss = {
                    isDropdownVisible = false
                },
                countryCodes = countryList,
                onCountryCodeSelection = {
                    onCountryCodeChange.invoke(it)
                }
            )
        }
    }
}

@Composable
inline fun DropDownLongList(
    modifier: Modifier = Modifier.heightIn(max = 350.dp).fillMaxWidth(0.85f),
    crossinline onDismiss:()->Unit,
    countryCodes: List<CountryShared>,
    crossinline onCountryCodeSelection:(String)-> Unit
) {

    var query by remember { mutableStateOf("") }
    val filteredCountries = countryCodes.filter {
        it.name.contains(query, ignoreCase = true) || it.code.contains(query, ignoreCase = true)
    }

    Dialog(
        onDismissRequest = { onDismiss.invoke() }) {
        Surface(
            modifier = modifier,
            shape = RoundedCornerShape(8.dp),
            shadowElevation = 8.dp
        ) {
            Column {
                // Search bar
                TextField(
                    value = query,
                    onValueChange = { query = it },
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(8.dp),
                    placeholder = { Text("Search...") }
                )

                // Filtered list
                LazyColumn {
                    items(filteredCountries) { country ->
                        Text(
                            text = "${country.emoji} ${country.name} (${country.dailCode})",
                            modifier = Modifier
                                .fillMaxWidth()
                                .clickable {
                                    onCountryCodeSelection.invoke(country.dailCode)
                                    onDismiss.invoke()
                                }
                                .padding(16.dp)
                        )
                    }
                }
            }
        }
    }
}

@Serializable
data class CountryShared(
    @SerialName("name") val name: String,
    @SerialName("dial_code") val dailCode: String,
    @SerialName("emoji") val emoji: String,
    @SerialName("code") val code: String,
)
